export const getFilteredImagesByRole = (images, roleToFilter) => {
    return images.filter((image) => {
        if (!image.role) {
            return true;
        }
        return !image.role.includes(roleToFilter);
    });
};
//# sourceMappingURL=getFilteredImagesByRole.js.map